import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';

/** Configuracao do sistema: visivel apenas para admin. */
const ProjectsMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { isAdmin } = useSessionContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!isAdmin) return <></>;

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Projetos',
        icon: <FolderSpecialIcon sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={() => navigate('/projects', { replace: true })}
    />
  );
};

export { ProjectsMenu };
